/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
export const palette = {
  primary: "#8A000B",
  primaryDark: "#600007",
  secondary: "#8A000B",
  sapphire: {
    main: "#0091FF",
    light: "#54B5FF",
    dark: "#016FC2",
  },
  text: {
    primary: "#43484C",
    secondary: "#5E6977",
    disabled: "#C9C9C9",
    highlight: "#f44336",
    alert: "#A42828",
    expandedMenu: "#FFFFFF",
  },
  border: {
    main: "#767676",
    hover: "#F0F4F7",
    alert: "#C10C0D",
  },
  divider: {
    dark: "#767676",
  },
  background: {
    default: "#F5F5F5",
    paper: "#FFFFFF",
    transparency: "CC",
  },
  disabled: {
    background: "#F5F5F5",
  },
};
